import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Textarea.scss';

const Textarea = ({ id, type, value, inputChange, inputBlur = () => {}, isError = false, placeholder = null, label = null, extraAttrs = {} }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandler = (e) => {
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	placeholder = placeholder || null;
	label = label || null;
	const labelClasses = [];
	if (isError === true) labelClasses.push(s.label__error);

	const input = <textarea className={s.input} id={id} name={id} type={type} value={value || ''} placeholder={placeholder} onChange={inputChangeHandlar} onBlur={inputBlurHandler} {...extraAttrs} />;

	if (label) {
		return (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				<span className={s.input_labelText}>{ label }</span>
				{ input }
			</label>
		);
	}
	return input;
};

export default hot(module)(Textarea);
